export const pricing = {
  price: '$19.990',
  currencyNote: 'pesos argentinos',
  fullValue: '$149.800',
  bonusesValue: '$99.900',
  bonusUnitValue: '$19.980',
  lineItems: [
    { label: '5 Tomos digitales completos', price: '$49.900' },
    { label: '5 Bonos exclusivos', price: '$99.900' },
  ],
}
